import { Link } from "react-router-dom";
import { Leaf, Mail, Phone, MapPin } from "lucide-react";
import { SITE, NAV_LINKS, LEGAL_LINKS } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-forest text-cream" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <Leaf className="h-5 w-5 text-amber" strokeWidth={1.6} />
              <span className="font-heading text-2xl font-medium uppercase tracking-[0.18em]">
                {SITE.name}
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-cream/70">
              {SITE.tagline} Crafted from organically grown apples, slow-fermented for real wellness.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-amber">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-cream/75 transition-colors duration-200 hover:text-amber"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-amber">Policies</h4>
            <ul className="mt-5 space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace("/", "")}`}
                    className="text-sm text-cream/75 transition-colors duration-200 hover:text-amber"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-amber">Get in touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-cream/75">
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-amber" strokeWidth={1.6} />
                <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-amber">
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-amber" strokeWidth={1.6} />
                <a href={`tel:${SITE.phoneHref}`} data-testid="footer-phone" className="hover:text-amber">
                  {SITE.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-amber" strokeWidth={1.6} />
                <span>{SITE.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-cream/15 pt-8 text-xs text-cream/55 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {SITE.legal}. All rights reserved.</p>
          <p className="max-w-lg">
            These statements have not been evaluated by the FDA. Our products are not intended to
            diagnose, treat, cure, or prevent any disease.
          </p>
        </div>
      </div>
    </footer>
  );
}
